<script setup lang="ts">
import { computed } from 'vue'
import {
  useStepDeliveryEditPageQuery,
  useUpdateStepDeliveryMutation,
} from './StepDeliveryEditPage.generated'
import { useRoute } from 'vue-router'
import StepDeliveryEditPageContent from './StepDeliveryEditPageContent.vue'
import type {
  UpdateStepDeliveryInput,
  CreateStepDeliveryInput,
} from '@/types/schema.generated'
import { useAlert } from '@/libs/alertPortal'
import LineMessageSendingIndexPageSideMenu from '@/pages/ChatMessageSendingJobIndexPage/ChatMessageSendingJobIndexPageSideMenu.vue'
import CenteredPageContainer from '@/components/molecules/CenteredPageContainer.vue'

const route = useRoute('StepDeliveryEditPage')

const alert = useAlert()

const stepDeliveryGUID = route.params.stepDeliveryGUID as string

const pageQuery = useStepDeliveryEditPageQuery({ guid: stepDeliveryGUID })

const stepDelivery = computed(() => {
  return pageQuery.result?.value?.stepDelivery
})

const updateMutation = useUpdateStepDeliveryMutation()

const handleSubmit = async (
  input: UpdateStepDeliveryInput | CreateStepDeliveryInput
) => {
  if (!stepDelivery.value) {
    return
  }

  const result = await updateMutation.mutate({
    input: {
      ...input,
      guid: stepDelivery.value.guid,
    },
  })

  if (!result || !result.data) {
    console.error('Mutation failed')
    return
  }

  alert.success('ステップ配信を更新しました')

  pageQuery.refetch()
}
</script>

<template>
  <CenteredPageContainer :class="$style.page" wide>
    <div :class="[$style.page__main, $style.setting]">
      <LineMessageSendingIndexPageSideMenu />
      <section :class="$style.wrapper">
        <div :class="$style.container">
          <StepDeliveryEditPageContent
            v-if="pageQuery.result.value"
            :payload="pageQuery.result.value.stepDelivery"
            @submit="handleSubmit"
          />
        </div>
      </section>
    </div>
  </CenteredPageContainer>
</template>

<style module lang="scss">
.wrapper {
  margin: 0 auto;
  width: 100%;
}

.container {
  background-color: $color-surface-primary;
  padding: 16px;
  border-radius: 10px;
}

.page {
  padding-bottom: 80px;

  &__header {
    &:nth-child(n + 2) {
      margin-top: 40px;
    }
  }

  &__main {
    &:nth-child(n + 2) {
      margin-top: 32px;
    }
  }
}

.setting {
  display: grid;
  align-items: flex-start;
  gap: 40px;
  grid-template-columns: 302px 1fr;
  grid-template-rows: auto;
}
</style>
